import React from 'react';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import {ASSET_IMAGES} from "../../utils/constants/paths";


const Logo = ({mini, mode, sx, href, logo_url, link_sx, img_style}) => {
    return (
        <Div sx={{display: "inline-flex", ...sx}}>
            <Link href={href} sx={link_sx}>
                {
                    logo_url ?
                        <img src={logo_url} style={img_style} />
                        :
                        !mini ?
                            <img style={{height: '60px'}} src={ mode === "light" ? `${ASSET_IMAGES}/logos/xpit_logo_isotype.png` : `${ASSET_IMAGES}/logos/xpit_logo_isotype.png`} alt="Xpit logo" />
                            :
                            <img style={{height: '60px'}} src={mode === "light" ? `${ASSET_IMAGES}/logos/xpit_logo_isotype.png` : `${ASSET_IMAGES}/logos/xpit_logo_isotype.png`} alt="Xpit logo" />
                }
            </Link>
        </Div>
    );
};

Logo.defaultProps = {
    mode: "light"
};

export default Logo;
